// src/pages/CheckoutPage.js
import React, { useEffect, useRef } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from '../components/OrderProcess/CheckoutForm';
import styles from '../styles/CheckoutPage.module.css';

// Initialize Stripe with the publishable key from environment variables
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const CheckoutPage = () => {
  console.log("Rendering Checkout Page");
  const pageTopRef = useRef(null);
  
  // Scroll to the top of the page when component mounts
  useEffect(() => {
    // Method 1: Using window.scrollTo
    window.scrollTo(0, 0);
    
    // Method 2: Using the ref (as a backup)
    if (pageTopRef.current) {
      pageTopRef.current.scrollIntoView({ behavior: 'auto' });
    }
  }, []);
  
  // Define the Stripe appearance options
  const appearance = {
    theme: 'stripe',
    variables: {
      colorPrimary: '#6772e5',
      colorBackground: '#ffffff',
      colorText: '#32325d',
      colorDanger: '#ff5252',
      fontFamily: 'Segoe UI, sans-serif',
      spacingUnit: '4px',
      borderRadius: '4px',
    },
  };

  // Configure Stripe Elements options
  const options = {
    appearance,
    locale: 'en',
  };
  
  return (
    <div className={styles.container} ref={pageTopRef}>
      <Elements stripe={stripePromise} options={options}>
        <CheckoutForm />
      </Elements>
    </div>
  );
};

export default CheckoutPage;